module.exports = __webpack_public_path__ + "static/media/instituteInsights.390dc6ff.svg";